import { FilterType } from 'components/entityViewer/entitiesDropDownFilter/entityFilterControls/FilterType';
import { toApi } from 'shared';
import dayjs from 'utils/dayjsConfig';

import { CreatedDateFilterMenuItem } from './CreatedDateFilterMenuItem';

export const BATCH_SHIPMENT_STATUS_OPTIONS = [
    { value: 'LABEL_PURCHASED', label: 'Label Purchased' },
    { value: 'LABEL_PRINTED', label: 'Label Printed' },
    { value: 'PACKED', label: 'Packed' },
    { value: 'SCANNING_TO_PALLET', label: 'Scanning to Pallet' },
    { value: 'ON_SHIPPING_PALLET', label: 'On Shipping Pallet' },
    { value: 'ON_TRUCK', label: 'On Truck' },
    { value: 'SHIPPED', label: 'Shipped' },
    { value: 'IN_TRANSIT', label: 'In Transit' },
    { value: 'OUT_FOR_DELIVERY', label: 'Out for Delivery' },
    { value: 'DELIVERED', label: 'Delivered' },
    { value: 'MIXED', label: 'Mixed' },
];

export const createdFilterConfig = {
    key: 'createdFilter',
    label: 'Created',
    type: FilterType.DATE_RANGE,
    menuComponent: CreatedDateFilterMenuItem,
    deletable: true,
};

export const hubContainsFilterConfig = {
    key: 'hubContains',
    label: 'Hub',
    type: FilterType.TEXT,
    deletable: true,
    menuProps: {
        placeholder: 'Contains hub...',
    },
};

export const sourceContainsFilterConfig = {
    key: 'sourceContains',
    label: 'Source',
    type: FilterType.TEXT,
    deletable: true,
    menuProps: {
        placeholder: 'Contains source...',
    },
};

export const shipmentStatusFilterConfig = {
    key: 'shipmentStatus',
    label: 'Shipment Status',
    type: FilterType.SELECT,
    multi: true,
    options: BATCH_SHIPMENT_STATUS_OPTIONS,
    deletable: true,
    menuProps: {
        placeholder: 'Select status...',
    },
};

export const BatchFilterConfigArray = [
    createdFilterConfig,
    hubContainsFilterConfig,
    sourceContainsFilterConfig,
    shipmentStatusFilterConfig,
];

/** @type {import('shared/utils/filterTransformers').FilterTransformConfig} */
export const BatchTransformConfig = {
    stringArrayKeys: ['hubContains', 'sourceContains', 'shipmentStatus'],
};

function formatDateValue(value) {
    if (!value) return undefined;
    const parsed = dayjs(value);
    if (!parsed.isValid()) return undefined;
    return parsed.format('YYYY-MM-DD');
}

/**
 * @param {Object} filters
 * @returns {Object}
 */
export function batchFiltersToApi(filters) {
    const { createdFilter, ...rest } = filters;
    const api = toApi(rest, BatchTransformConfig);

    if (createdFilter && typeof createdFilter === 'object') {
        if (createdFilter.mode === 'on') {
            const createdDate = formatDateValue(createdFilter.date);
            if (createdDate) {
                api.createdDate = createdDate;
            }
        } else {
            const createdFrom = formatDateValue(createdFilter.startDate);
            const createdTo = formatDateValue(createdFilter.endDate);
            if (createdFrom) {
                api.createdFrom = createdFrom;
            }
            if (createdTo) {
                api.createdTo = createdTo;
            }
        }
    }

    return api;
}
